<template>
    <div>
        <DataTable :columns="getColumns()" :id="id" :show_buttons="show_buttons" :show_contadores="show_contadores" :show_search="show_search"
            url="processos" :hiddenButtons="['Arquivo']" :custom_params="custom_params" :show_filters="show_filters">
            <template v-slot:checkbox="{ row }">
                <e-checkbox v-bind="row.checkbox"></e-checkbox>
            </template>
            <template v-slot:interessado="{ row }">
                <div class="d-flex flex-column" v-if="row.interessado && row.interessado.cliente">
                    <span>{{ row.interessado.cliente }}</span>
                    <small>{{ row.interessado.interessado }}</small>
                </div>
                <span v-else>{{ row.interessado.interessado }}</span>
            </template>
            <template v-slot:status_id="{ row }">
                <status :row="row" />
            </template>
            <template v-slot:actions="{ row }">
                <div class="d-flex align-items-center flex-wrap" style="width: 100%; max-width:200px">
                    <b-button v-if="row.processo_automatizado && row.arquivado == 0"
                        :href="`https://app.econsulte.com/processos/ver_na_prefeitura/${row.id}/${row.municipio_id}`"
                        target="_blank" size="sm" variante="outline-secondary" title="ver direto no site da prefeitura"><i
                            class="fa fa-eye" id="fancy"></i></b-button>                </div>

            </template>
        </DataTable>
        
        <modal title="Configurações de notificação" size="md" id="notificationProcesso">
            <Notification :processo="processo"></Notification>
        </modal>
    
    </div>
</template>



<script>

import { mapMutations, mapState } from "vuex";
import DataTable from "../sistema/DataTable.vue";
import eCheckbox from "../sistema/eCheckBox.vue";

import Status from "./Status.vue";
import Notification from "./forms/Notification.vue";
import BtnLembrete from "../sistema/BtnLembrete.vue";
import BtnAnexo from "../sistema/BtnAnexo.vue";
import BtnWhatsapp from "../sistema/BtnWhatsapp.vue";

export default {
    components: { DataTable, eCheckbox, Status, BtnLembrete, BtnAnexo, Notification, BtnWhatsapp},
    key: "pefeitura",
    data() {
        return {
            cliente_id: null,
            tarefa_id: null,
            processo: null,
            processo_id: null,
            filter: {
                tipos: [],
                status: [],
            },
            // custom_params: {
            //   municipio_id: this.prefeitura_id,
            //   orgao_id: this.orgao_id,
            //   filter: [{ name: 'arquivado', value: 0 }]
            // },
        };
    },
    props: {
        id: 'single-processo-table',
        custom_params: Object,
        show_contadores: Boolean,
        show_search: Boolean,
        show_filters: Boolean,
        show_buttons: Boolean,
        prefeitura_id: "",
        orgao_id: "",
        title: { default: "TITULO" },
    },
    methods: {
        ...mapMutations('actions', ['ocultar', 'put']),
        getColumns() {
            return [
                { key: "checkbox", label: "<i class='fas fa-star text-warning'></i>" },
                { key: "interessado", label: "Interessado" },
                { key: "processo", label: "Numero/Ano" },
                {
                    key: "tipo_id",
                    label: "Tipo",
                    filter: { value: "", route: "processo/tipoList" },
                },
                {
                    key: "status_id",
                    label: "Status",
                    //  filter: { value: "", route: "processo/statusList" },
                },
                { key: "processo_setor", label: "Setor" },
                { key: "processo_last_update", label: "Último movimento", sortable: true },
                { key: "ultimo_comentario", label: "Última atualização"},
                { key: "actions", label: "Ações" },
            ];
        },
    },
};
</script>
